module.exports = __webpack_public_path__ + "img/fingerprint-01.69a526a3.svg";